import { __decorate, __metadata } from "tslib";
import { Serialize } from '@ftr/serialization';
import { ZonedDateTime } from '@js-joda/core';
export class CourtSystemUseConditions {
}
__decorate([
    Serialize(() => ZonedDateTime),
    __metadata("design:type", ZonedDateTime
    /**
     * When true, the conditions will be shown to users for acceptance
     */
    )
], CourtSystemUseConditions.prototype, "publishedTimestamp", void 0);
